// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__8r4Ua","inner":"Footer_inner__1a0Ga","nextIcon":"Footer_nextIcon__KLOUf","innerLeft":"Footer_innerLeft__1KwI5"};